// Service catalog. Top-level services (11) + junk spokes (4).
// Full page copy is added on each service page template in Phase 2.

export const TOP_SERVICES = [
  { slug: "junk-removal", title: "Junk Removal", icon: "Trash2", pillar: true,
    blurb: "The whole shebang! We haul away almost anything that is cluttering up your space." },
  { slug: "furniture-removal", title: "Furniture Removal", icon: "Sofa",
    blurb: "Couches, dressers, that recliner nobody sits in anymore. Up the stairs and gone!" },
  { slug: "mattress-disposal", title: "Mattress Disposal", icon: "BedDouble",
    blurb: "Old mattresses and box springs hauled off and recycled the right way." },
  { slug: "appliance-removal", title: "Appliance Removal", icon: "Refrigerator",
    blurb: "Fridges, washers, dryers and more. We handle freon appliances specially." },
  { slug: "hot-tub-removal", title: "Hot Tub Removal", icon: "Waves",
    blurb: "We break it down, carry it out and give you your patio back. Poof!" },
  { slug: "garage-cleanouts", title: "Garage Cleanouts", icon: "Warehouse",
    blurb: "Park your car again! We clear out years of stuff in one visit." },
  { slug: "estate-cleanouts", title: "Estate Cleanouts", icon: "Home",
    blurb: "Careful, respectful whole home cleanouts during a tough season." },
  { slug: "rental-property-cleanouts", title: "Rental Property Cleanouts", icon: "Key",
    blurb: "Fast tenant turnovers so landlords can relist and get back to earning." },
  { slug: "yard-debris-removal", title: "Yard Debris Removal", icon: "Leaf",
    blurb: "Branches, brush, storm debris and old fencing hauled clean away." },
  { slug: "light-demolition-hauling", title: "Light Demolition Hauling", icon: "Hammer",
    blurb: "Sheds, decks, flooring and remodel debris knocked down and carried off." },
  { slug: "heavy-material-hauling", title: "Heavy Material Hauling", icon: "Truck",
    blurb: "Concrete, tile, brick and dirt. The heavy stuff nobody else wants to lift." },
];

export const JUNK_SPOKES = [
  { slug: "junk-hauling", title: "Junk Hauling", icon: "Truck",
    blurb: "Big, heavy, trailer load hauling jobs when you have a whole lot to move." },
  { slug: "junk-pickup", title: "Junk Pickup", icon: "PackageCheck",
    blurb: "Quick single item and curbside pickups. Point at it and it is gone." },
  { slug: "same-day-junk-removal", title: "Same Day Junk Removal", icon: "Zap",
    blurb: "Need it gone today? We move fast. That is kind of our whole thing!" },
  { slug: "commercial-junk-removal", title: "Commercial Junk Removal", icon: "Building2",
    blurb: "Offices, property managers and businesses. Cleared out without the fuss." },
];

export const ALL_SERVICES = [...TOP_SERVICES, ...JUNK_SPOKES];

export const getService = (slug) => ALL_SERVICES.find((s) => s.slug === slug);
export const servicePath = (s) =>
  JUNK_SPOKES.some((x) => x.slug === s.slug)
    ? `/services/junk-removal/${s.slug}`
    : `/services/${s.slug}`;
